import React from "react";
import Modal from "../modal/Modal";
import { MdDelete } from "react-icons/md";
import TextComponent from "../textComponent/TextComponent";
import SubmitButton from "../submitButton/SubmitButton";
import styles from "./deleteModal.module.css";
import { Row } from "antd";

function DeleteModal({
  deleteModalOpen,
  setDeleteModalOpen,
  delDesc,
  title,
  onSubmit,
}) {
  return (
    <Modal
      isModalOpen={deleteModalOpen}
      setIsModalOpen={setDeleteModalOpen}
      closable={true}
      pinkBg={true}
    >
      <Row className={styles.modalContent}>
        <MdDelete className={styles.deleteIcon} />
        <div>
          <TextComponent textClass={styles.modalText1}>{delDesc}</TextComponent>
          <TextComponent textClass={styles.modalText2}>{title}</TextComponent>
        </div>
        <div className={styles.modalBtnContainer}>
          <SubmitButton
            title="Delete"
            btnClass={styles.modalBtn}
            onClick={() => {
              onSubmit();
              setDeleteModalOpen(false);
            }}
          />
          <SubmitButton
            title="Cancel"
            outline={true}
            btnClass={styles.modalBtn}
            onClick={() => setDeleteModalOpen(false)}
          />
        </div>
      </Row>
    </Modal>
  );
}

export default DeleteModal;
